import React from "react";
import { social } from "../Data";
import { FaCopyright } from "react-icons/fa";
const Footer = () => {
	return (
		<footer>
			<div className="icon">
				<ul className="footer-icons">
					{social.map((item) => {
						const { id, url, icon } = item;
						return (
							<li key={id}>
								<a href={url}>{icon}</a>
							</li>
						);
					})}
				</ul>
			</div>
				<FaCopyright /> {new Date().getFullYear()} designed and built by ibrahim abdulsalami
		</footer>
	);
};

export default Footer;
